import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { GameResult, LevelResult } from '../../types';

interface LevelResultsState {
  levelResults: LevelResult[];
  cumulativeScore: number;
  lastGameResult: GameResult | null;
}

const initialState: LevelResultsState = {
  levelResults: [],
  cumulativeScore: 0,
  lastGameResult: null,
};

export const levelResultsSlice = createSlice({
  name: 'levelResults',
  initialState,
  reducers: {
    resetLevelResults: () => initialState,

    addLevelResult: (state, action: PayloadAction<LevelResult>) => {
      const levelResult = action.payload;
      return {
        ...state,
        levelResults: [...state.levelResults, levelResult],
        cumulativeScore: state.cumulativeScore + levelResult.score,
      };
    },

    setLastGameResult: (state, action: PayloadAction<GameResult>) => ({
      ...state,
      lastGameResult: action.payload,
    }),

    updateCumulativeScore: (state, action: PayloadAction<number>) => ({
      ...state,
      cumulativeScore: state.cumulativeScore + action.payload,
    }),

    setCumulativeScore: (state, action: PayloadAction<number>) => ({
      ...state,
      cumulativeScore: action.payload,
    }),

    clearLastGameResult: (state) => ({
      ...state,
      lastGameResult: null,
    }),

    // Helper action to reset just the current game results while keeping historical data
    resetCurrentGameResults: (state) => ({
      ...state,
      levelResults: [],
      cumulativeScore: 0,
      lastGameResult: null,
    }),
  },
});

export const {
  resetLevelResults,
  addLevelResult,
  setLastGameResult,
  updateCumulativeScore,
  setCumulativeScore,
  clearLastGameResult,
  resetCurrentGameResults,
} = levelResultsSlice.actions;

export default levelResultsSlice.reducer;
